import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface Props {
    deleteAllowed: boolean;
    formIsInvalid: boolean;
    handleOnChange: CallableFunction;
    name: string;
    onCancelClickHandler: CallableFunction;
    onDeleteClickHandler: CallableFunction;
    onSaveClickHandler: CallableFunction;
}

const ClassFormHeader: React.FC<Props> = ({
    deleteAllowed,
    formIsInvalid,
    handleOnChange,
    name,
    onCancelClickHandler,
    onDeleteClickHandler,
    onSaveClickHandler,
}: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));

    return (
        <>
            <div className="class-header-form">
                <input
                    className="input-title"
                    maxLength={100}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange('name', e.target.value)}
                    placeholder={strings.CLASS_TITLE_PLACEHOLDER}
                    required
                    type="text"
                    value={name}
                />
                <div className="class-form-action justify-content-end">
                    {deleteAllowed && (
                        <button className="btn btn-link btn--delete" onClick={() => onDeleteClickHandler()}>
                            <span>{strings.DELETE}</span>
                        </button>
                    )}
                    <button className="btn btn-link btn--cancel" onClick={() => onCancelClickHandler()}>
                        <span>{strings.CANCEL}</span>
                    </button>
                    <button className="btn btn-link btn--edit" disabled={formIsInvalid} onClick={() => onSaveClickHandler()}>
                        <span>{strings.SAVE}</span>
                        <i className="material-icons icon">{Constants.icons.SAVE}</i>
                    </button>
                </div>
            </div>
        </>
    );
};

export default ClassFormHeader;
